import * as Sentry from "@sentry/react";
import { tx } from "@transifex/native";
import { useCallback, useEffect, useState } from "react";
import { cp } from "../../config";
import { LAST_TX_LANG_STORAGE_KEY, SUPPORTED_TX_LOCALES } from "../../helpers/TxLocaleHelper";

interface DevLanguageSelectorProps {
    className?: string;
}

const LANGUAGES = SUPPORTED_TX_LOCALES.map((locale) => ({ key: `lang_${locale}`, value: locale, label: locale }));

export const DevLanguageSelector = (props: DevLanguageSelectorProps) => {
    const [currentSelectedLanguage, setCurrentSelectedLanguage] = useState("");

    const canShow = cp.cfg.ENVIRONMENT && cp.cfg.ENVIRONMENT !== "prod";

    useEffect(() => {
        setCurrentSelectedLanguage(tx.getCurrentLocale() || "");
    }, []);

    const handleChange = useCallback((newLanguage: string) => {
        tx.setCurrentLocale(newLanguage)
            .catch((error) => {
                console.error("Failed to load translations", error);
                Sentry.captureException(error, { extra: { locale: newLanguage } });
            })
            .finally(() => {
                setCurrentSelectedLanguage(tx.getCurrentLocale() || "");
                localStorage.setItem(LAST_TX_LANG_STORAGE_KEY, newLanguage);
            });
    }, []);

    if (!canShow) return null;

    return (
        <div className={props.className}>
            <select
                value={currentSelectedLanguage}
                onChange={(ev) => handleChange(ev.target.value)}
            >
                {LANGUAGES.map((lang) => (
                    <option
                        key={lang.key}
                        value={lang.value}
                    >
                        {lang.label}
                    </option>
                ))}
            </select>
        </div>
    );
};
